<template>
  <div class="container-fluid">
    <div class="heightcontainer">
      <landing-navbar></landing-navbar>
      <section class="section1 mt-2 pb-4">
          <div class="container pt-lg-5 pb-lg-5 row no-gutters mx-auto ">
                <div class="col-12 mt-5">
                    <div class="col-lg-12 mt-lg-5 text-center section1content">
                        <div class="vertical-center mt-lg-5 top-padding pl-md-3 pr-md-3">   
                          <h2 class="font48-bold-main proximanova-bold">Engage your audience through short-videos, video profiles and more</h2>  
                          <!-- <h2 class="font48-bold-main proximanova-bold">climbing up the ladder of success</h2>                      -->
                          <p class="font24-reg-main pl-md-3 pr-md-3 mt-4 proximanova">Grow your professional network and build fruitful business relationships. Connect and Be Seen, to the world of opportunities. Sign up for a professional journey that’s both exciting and enriching at the same time.</p>
                        </div>
                        <div class="pb-3 pl-md-3 pr-md-3 mt-4">
                          <button class="btn button-create p-2 mt-3 pl-3 pr-3 borderradius20 mouseoverbtn2 backgroundcolorblack proximanova-semibold white" @click="NavToSignup">Signup for Professional</button>
                          <button class="btn button-create p-2 mt-3 pl-3 ml-md-4 pr-3 borderradius20 mouseoverbtn1 borderblack black proximanova-semibold" @click="NavToBusinessAccount">Signup for Business</button>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="section1 mt-2 pb-5">
          <div class="container-fluid pb-lg-5 mt-md-0 row no-gutters mx-auto containerfluidcontent">
            <div class="col-12 pl-3 pr-3 pl-md-2 pr-md-2 pl-lg-0 pr-lg-0 mb-4 d-lg-flex">
              <div class="col-lg-6 my-auto pl-0 pr-0 text-left">
                <div class="vertical-center my-auto top-padding pl-md-3 pr-md-3">  
                  <h2 class="font40-bold-main proximanova-bold">Everything you need to make a lasting impression</h2>                     
                <p class="font24-reg-main mt-4 mb-1 proximanova pointerIcon">Post video resumes for employers, telling them about your skills and experience. Add text transitions, filters, and audio to make it even more appealing. Building a Video Resume with Worknotion will help you create a lasting impression in your employer’s mind.</p>
                </div>
              </div>
              <div class="col-lg-6 pl-0 pr-0 text-center d-flex justify-content-between my-auto">
                <img src="../../assets/userLandingimg2.webp" class="img-fluid col-12 col-md-10 pl-0 pr-0 doubleborder secondImg2 mt-md-5" alt="worknotion">
                <div></div>
                <div class="col-12 col-md-10 pull-right mt-3 mt-lg-5 backgroundimage moveToRightImg d-none d-md-block">
                  <img src="../../assets/backgroundImg1.png" class="col-12" alt="">
                </div>
              </div>
            </div>
          </div>
        </section> 
        <section class="section1 backgroundcolor10 mt-2 pb-5">
          <div class="container-fluid pb-lg-5 row no-gutters mx-auto containerfluidcontent">
            <div class="col-12 pl-3 pr-3 pl-md-2 mt-5 mt-md-0 pr-md-2 pl-lg-0 pr-lg-0 d-lg-flex">
              <div class="col-lg-6 pl-0 pr-0 text-center my-auto">
                <div class="col-12 col-md-10 mt-5 backgroundimage d-none d-md-block">
                  <img src="../../assets/backgroundImg2.png" class="col-12" alt="worknotionbg">
                </div>
                <img src="../../assets/userLandingimg3.webp" class="img-fluid col-12 col-md-10 mb-3 pl-0 pr-0 doubleborder secondImg1 mt-3 mt-md-5" alt="worknotion">
              </div>
              <div class="col-lg-6 pl-0 pr-0 my-auto text-left">
                <div class="vertical-center my-auto top-padding pl-md-3 pr-md-3">   
                  <h2 class="font40-bold-main proximanova-bold mt-2">Become an influencer</h2>                     
                <p class="font24-reg-main mt-4 mb-1 proximanova">Share your professional experiences with your audience through short videos and grow your network manifold to increase reach and build a professional network. Connect with and guide the people in your network and increase the trust score on your profile.</p>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section class="section1 mt-2 pb-5">
          <div class="container-fluid pb-lg-5 mt-md-0 row no-gutters mx-auto containerfluidcontent">
            <div class="col-12 pl-3 pr-3 pl-md-2 mt-4 pr-md-2 pl-lg-0 pr-lg-0 mb-4 d-lg-flex">
              <div class="col-lg-6 my-auto pl-0 pr-0 text-left">
                <div class="vertical-center my-auto top-padding pl-md-3 pr-md-3">  
                  <h2 class="font40-bold-main proximanova-bold">Leverage on-platform capabilities for growth</h2>                     
                  <p class="font24-reg-main mt-4 proximanova">Use pre-loaded editable video templates to showcase key skills, share information,experiences, and more within your network to make a mark. With professionals from around the world watching your content, chances of your growth increase manifold.</p>
                </div>
              </div>
              <div class="col-lg-6 pl-0 pr-0 text-center d-flex justify-content-between my-auto">
                <img src="../../assets/userLandingimg4.webp" class="img-fluid col-12 col-md-10 pl-0 pr-0 doubleborder secondImg2 mt-md-5" alt="worknotion">
                <div></div>
                <div class="col-12 col-md-10 pull-right mt-3 mt-lg-5 backgroundimage moveToRightImg d-none d-md-block">
                  <img src="../../assets/backgroundImg3.png" class="col-12" alt="worknotionbg">
                </div>
              </div>
            </div>
          </div>
        </section> 
        <section class="section1 backgroundcolor10 mt-2 pb-5">
          <div class="container-fluid pb-lg-5 row no-gutters mx-auto containerfluidcontent">
            <div class="col-12 pl-3 pr-3 pl-md-2 mt-5 mt-md-0 pr-md-2 pb-5 pl-lg-0 pr-lg-0 d-lg-flex">
              <div class="col-lg-6 pl-0 pr-0 text-center my-auto pb-md-5">
                <div class="col-12 col-md-10 mt-5 backgroundimage d-none d-md-block pb-md-5 mb-md-5 mb-lg-0">
                  <img src="../../assets/backgroundImg4.png" class="col-12" alt="worknotionbg">
                </div>
                <img src="../../assets/LandingTrackingDetails.webp" class="img-fluid col-12 col-md-10 mb-3 pl-0 pr-0 doubleborder secondImg1 mt-3 mt-md-5" alt="worknotion">
              </div>
              <div class="col-lg-6 pl-0 pr-0 my-auto text-left">
                <div class="vertical-center my-auto top-padding pl-md-3 pr-md-3">   
                  <h2 class="font40-bold-main proximanova-bold mt-3 mt-md-2">Apply to Jobs and Track application status</h2>                     
                  <p class="font24-reg-main mt-4 mb-1 proximanova">Manage your applied jobs and stay updated by tracking your job application status, all in one place.Today’s discussions can open you to the best opportunities tomorrow. Be a part of a professional network that will aid your career growth.</p>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section class="section2 pt-4 pb-5 pl-3 pr-3 pl-md-5 pr-md-5 pr-lg-0">
          <div class="container-fluid pt-5 pb-5 containerfluidcontent">
            <div class="col-lg-12 text-center">
              <div class="vertical-center pt-lg-5 pb-lg-5 pl-md-3 pr-md-3">   
                <h2 class="font40-bold-main proximanova-bold">Privacy and Information Security? You don’t have to ask!</h2>                     
                <p class="font24-reg-main mt-4 proximanova">Worknotion respects user privacy and follows a strict information use and store policy to safeguard personal user data.With state-of-the-art information security protocols, we ensure your privacy isn’t compromised at all. For more information, read through our Privacy Policy page.</p>
              </div>
            </div>
          </div>
        </section>  
        <section class="section3 backgroundcolor10 pt-5 pb-5 pl-3 pr-3 pl-md-5 pr-md-5 pr-lg-0">
          <div class="container-fluid pt-5 pb-5 d-md-flex containerfluidcontent">
            <div class="col-lg-12">
              <div class="vertical-center pl-md-3 pr-md-3">   
                <h2 class="font48-bold-main proximanova-bold">Your one-stop destination for every career opportunity.</h2>                       
              </div>
              <div class="pb-3 pl-md-3 pr-md-3 mt-4">
                <button class="btn button-create p-2 mt-3 pl-5 pr-5 mouseoverbtn2 borderradius20 backgroundcolorblack proximanova-semibold white" @click="NavToSignup">Sign Up</button>
                <!-- <button class="btn button-create p-2 ml-2 mt-3 pl-5 mouseoverbtn1 ml-md-4 pr-5 borderradius20 borderblack black proximanova-semibold">Watch Demo</button> -->
              </div>
            </div>
          </div>
        </section> 
    </div>    
    <Footer class="footer" ></Footer>
  </div> 
</template>
<script>
import BottomFooter from "@/components/BottomFooter.vue";
import Footer from '../LandingFooter.vue'
import router from '../../router.js'
import LandingNavbar from './Navbar.vue'
import wndata from '../../js/wn_data.json'
import $ from 'jquery'
export default {
  components: {
    BottomFooter,   
    Footer,
    LandingNavbar
  },
  data() {
    return {
      newpassword: "Enter New Password",
      confirmpassword: "Enter Confirm Password *",
      newpassword: "",
      cpassword: "",
      show: false,
      signup: "Candidate",
      Candidate: "Candidate",
      Recruiter: "Recruiter",
      verificationdetails: true,
      terms: false,
      message: "",
      getotpdetails: false,
      emailidverification: true,
      isVideoPlaying : false,
    };
  },
  methods: {
    NavToSignup() {
      router.push({
        name : 'signup'
      })
    },
    play_follow() {
      var video = document.getElementById('videoTag')
      this.isVideoPlaying = !this.isVideoPlaying
      if(this.isVideoPlaying){
        video.play()
      }else{
        video.pause()
      }
    },
    switchVisibility() {
      const passwordField = document.querySelector("#password");
      if (passwordField.getAttribute("type") === "password")
        passwordField.setAttribute("type", "text");
      else passwordField.setAttribute("type", "password");
    },
    emailidverified() {
      this.message = "EmailIDVerified";
      if (this.message === "EmailIDVerified") {
        this.verificationdetails = true;
        this.getotpdetails = true;
        this.emailidverification = false;
      }
    },
    toggle() {
      this.show = !this.show;
    },
    backtosignup() {
      this.getotpdetails = false;
      this.verificationdetails = true;
      this.message = "";
    },
    NavToBusinessAccount(){
      var x = document.createElement('a')
      x.target = '_blank'
      x.href = wndata.companyAccountWebapp
      x.click()
    },
    NavToPricing() {
        router.push({
            name : 'pricing'
        })
    },
    getotp() {
      this.message = "gotOTP";
      if (this.message === "gotOTP") {
        this.verificationdetails = false;
        this.getotpdetails = true;
      }
    }
  },
  mounted: function() {
    window.scrollTo(0, 0)
  },
  computed: {
    isDisabled: function() {
      return !this.terms;
    }
  }
};
</script>
<style scoped>
.button-create{
  font-size: 18px !important;
}
.button-create:focus {
  outline: 0 !important;
}
.videocard{
  background: black;
  border-radius: 20px;
  padding: 25px 0;
}
#videoTag{
  width: 100%;
  /* background-image: linear-gradient(rgba(31, 31, 31, .1), rgba(31,31,31,.1)), url(''); */
}
.landingElementStyles{
  width: 150px;
  position: absolute;
  margin-top: -90px;
  z-index: 1;
}
.zindex1{
  z-index: 1 !important;
}
.zindex2{
  z-index: 2 !important;
}
.gradientColor1{
  /* background: -webkit-linear-gradient(rgb(27, 140, 233), rgb(147, 209, 209), rgb(2, 61, 61)) !important;
  -webkit-background-clip: text !important; */
  -webkit-text-fill-color: transparent !important;
  background: -webkit-linear-gradient(left, yellow , red);
   background: -o-linear-gradient(right, yellow , red);
   background: -moz-linear-gradient(right, yellow , red);
   background: linear-gradient(to right, yellow , red); 
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
.gradientColor2{
  background: -webkit-linear-gradient(#12c2e9, #c471ed, #f7797d) !important;
  -webkit-background-clip: text !important;
  -webkit-text-fill-color: transparent !important;
}
.gradientColor3{
  background: -webkit-linear-gradient(rgb(182, 44, 20), rgb(209, 203, 147), rgb(63, 175, 12)) !important;
  -webkit-background-clip: text !important;
  -webkit-text-fill-color: transparent !important;
}
#playvideobtn{
  margin-top: 60px !important;
}
.pausebtn{
  display: none;
  margin-top: 60px !important;
  margin-left: 44% !important;
}
.videocard:hover .pausebtn{
  display: block;
  margin-top: 75px !important;
}
@media (min-width: 992px){
  .containerfluidcontent{
    width: 85% !important;
  }
  .whatpeoplesayCard{
    position: absolute;
    z-index: 2;
    margin-top: 8%;
  }
  #videoTag{
    height: 460px !important;
  }
  #playvideobtn{
    margin-top: 200px !important;
  }
  .pausebtn{
    display: none;
    margin-top: 220px !important;
    margin-left: 48% !important;
  }
  .videocard:hover .pausebtn{
    display: block;
    margin-top: 215px !important;
  }
  .moveToRightImg{
    right: 0 !important;
  }
  .secondImg1{
    position: absolute;
    top: 0;
    right: 0;
    margin-top: 90px !important;
    margin-right: 40px !important;
  }
  .secondImgMain{
    margin-left: -200px !important;
  }
  .secondImgMain1{
    position: absolute;
    top: 0;
    right: 0;
    margin-top: 5% !important;
  }
  .secondImgMain2{
    position: absolute;
    top: 0;
    left: 0;
    margin-top: 5% !important;
  }
  .secondImg2{
    position: absolute;
    top: 0;
    right: 0;
    margin-top: 90px !important;
    margin-right: 100px !important;
    z-index: 2 !important;
  }
}
section {
 margin: 0 0 0rem 0rem  !important ;
}
.footer {
  background-color: black;       
  color : white;
  position: sticky;
}
.top-padding{
  padding-top:3rem !important;
}
h2{
  font-weight: 300;
}
.section1 {
  background-color:white;
}
.section2 {
  background-color:white;
}   
@media screen and (min-width: 300px) and (max-width: 350px) {
  .top-padding{
    padding-top:0rem !important;
  }
  .font24-reg-main{
    font-size: 16px;
  }
  .font48-bold-main {	
    font-size: 24px;	
  }
  .font40-bold-main{
    font-size: 20px;
  }
}
@media screen and (min-width: 350px) and (max-width: 400px) {
  .top-padding{
    padding-top:0rem !important;
  }
  .font24-reg-main{
    font-size: 16px;
  }
  .font48-bold-main {	
    font-size: 24px;	
  }
  .font40-bold-main{
    font-size: 20px;
  }
}
@media screen and (min-width: 300px) and (max-width: 600px) {
  .section1content{
    margin-top: 12% !important;
  }
  .top-padding{
    padding-top:0rem !important;
  }
}
@media screen and (min-width: 600px) and (max-width: 800px) {
  .section1content{
    margin-top: 12% !important;
  }
  #playvideobtn{
    margin-top: 160px !important;
  }
  .pausebtn{
    display: none;
    margin-top: 160px !important;
    margin-left: 46% !important;
  }
  .videocard:hover .pausebtn{
    display: block;
    margin-top: 175px !important;
  }
  .secondImg1{
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    margin-top: 50px !important;
    margin-left: 60px !important;
  }
  .secondImg2{
    position: absolute;
    top: 0;
    right: 0;
    margin-top: 70px !important;
    margin-right: 70px !important;
    z-index: 2 !important;
  }
}
@media screen and (min-width: 400px) and (max-width: 600px) {
  .top-padding{
    padding-top:0rem !important;
  }
  .font48-bold-main {	
    font-size: 28px;	
  }
  .font40-bold-main{
    font-size: 24px;
  }
  .font24-reg-main {
    font-size: 18px;
  }
}
@media screen and (max-width: 900px) and (min-width: 800px) {
  .top-padding{
    padding-top:0rem !important;
  }
}
@media screen and (max-width: 700px) and (min-width: 600px) {
  .top-padding{
    padding-top:0rem !important;
  }
}
@media screen and (max-width: 800px) and (min-width: 700px) {
  .top-padding{
    padding-top:0rem !important;
  }
}



</style>
